import jsKit from './jsKit';

const changeCurrency = async (e) => {
  const trigger = e.delegateTarget || e.currentTarget;
  if (!trigger?.value) {
    return;
  }

  const formData = new FormData();
  formData.append('change_currency[currency]', trigger.value);

  const data = await jsKit.requestUrl('/main/changeCurrency/', 'json', 'POST', formData);
  if (data?.validated) {
    window.location.reload();
  } else {
    jsKit.showErrors(data, 'body');
  }
};

export default { changeCurrency };
